module.exports = __webpack_public_path__ + "img/icon_inspect_rate.001a4583.png";